// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3fsNU","col":"styles_col__2EUqo","fulfillmentStatus":"styles_fulfillmentStatus__1WllA","emailCol":"styles_emailCol__2-O3H"};